import React from 'react'
import HistogramaCaladoPorPuestoView from '../../components/histogramas/HistogramaCaladoPorPuestoView'

function HistogramaCaladoPorPuesto () {
  return (<HistogramaCaladoPorPuestoView />)
}

export default HistogramaCaladoPorPuesto
